import { useContext } from "react";
import { StepsContext } from "../Context/stepsContext";

export const useStepsContext = () => useContext(StepsContext);